import React from 'react';

export default ({ locale }) => (
  <div style={{ fontSize: '10px'}}>
  <p>{locale.common.footer}</p>
  <a
      href="https://about.ascension.org/privacy"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#949494', marginRight: 8 }}
    >
      {locale.common.privacy_policy}
    </a>
    |
    <a
      href="https://about.ascension.org/chat-terms-conditions"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#949494', marginLeft: 8 }}
    >
      {locale.common.terms_of_use}
    </a>
    </div>
);
